import { Masonry } from "@mui/lab";
import { useTheme } from "@mui/material";
import { Box, Stack } from "@mui/system";
import Slider, { Settings } from "react-slick";
import { IDarkTheme } from "styles/darkTheme";
import TestmonialCard, { ITestimonialCard } from "../testimonialCard";
import border_test_right from "assets/landing_test_bot_right.png";
import border_test_left from "assets/landing_test_top_left.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./styles";
import { useLayoutEffect, useState } from "react";
type ITestimonialsSectionProps = {
  isSM: boolean;
  feedCards: ITestimonialCard[];
};

//Hook to rerender component on screen resize
function useWindowSize() {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}
const TestimonialsSection = ({
  isSM,
  feedCards
}: ITestimonialsSectionProps) => {
  const theme = useTheme<IDarkTheme>();
  const classes = styles();

  const [width] = useWindowSize();

  //Equation to calculate padding of carousel in form ax^2 + bx + c
  //Its params is calculated from points discovered by trial and error :D
  const curPadding =
    0.0000171265 * Math.pow(width, 2) + 0.46191 * width - 230.579;
  const settings: Settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: `${curPadding}px`,
    slidesToShow: 1,
    speed: 500,
    dots: true
  };
  return (
    <Stack
      sx={{
        width: "100%",
        backgroundColor: theme.colors.neutrals.neutrals_20,
        padding: isSM ? "24px" : "40px 54px",
        position: "relative"
      }}
    >
      {isSM ? (
        <>
          <p
            style={{
              alignSelf: "center",
              marginBottom: "24px"
            }}
            className={classes.featureTitle}
          >
            Testimonials
          </p>
          <Box className={classes.sliderStyled}>
            <Slider {...settings}>
              {feedCards.map((feed) => (
                <TestmonialCard {...feed} />
              ))}
            </Slider>
          </Box>
        </>
      ) : (
        <>
          <img
            loading="lazy"
            src={border_test_left}
            alt={"border left"}
            style={{
              position: "absolute",
              display: isSM ? "none" : "block"
            }}
          />
          <img
            loading="lazy"
            src={border_test_right}
            alt={"border right"}
            style={{
              position: "absolute",
              right: "54px",
              bottom: "40px",
              display: isSM ? "none" : "block"
            }}
          />
          <p
            style={{
              fontSize: theme.fontSize.heading_3,
              fontWeight: theme.fontWeight.big,
              color: theme.colors.neutrals.neutrals_90,
              alignSelf: "center"
            }}
          >
            Testimonials
          </p>
          <Box
            sx={{
              padding: "57px 38px",
              position: "relative"
            }}
          >
            <Masonry
              style={{
                width: "100%"
              }}
              columns={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 3
              }}
              spacing={2}
            >
              {feedCards.map((feed, idx) => (
                <TestmonialCard key={idx} {...feed} />
              ))}
            </Masonry>
          </Box>
        </>
      )}
    </Stack>
  );
};

export default TestimonialsSection;
